import { type AboutUsViewModel, AppName } from "src/http/types";
import { usePageModelData } from "src/shared/context/PageModelDataContext";

/*
 * WARNING - DO NOT MOVE THIS FILE
 * This file location is important to ensure our linting enforces we avoid unsafely accessing page model data
 * across different applications and shared components within this repo.
 */

/**
 * Returns the page model data specifically for the about us page.
 */
export const useAboutUsPageModelData = (): AboutUsViewModel => {
  const data = usePageModelData();
  if (data.appName !== AppName.AboutUs) {
    throw new Error("useAboutUsPageModelData must be used on the about us page only");
  }
  return data;
};
